const enum MediaContentTypes {
  ApplicationPdf = "application/pdf",
}

export default MediaContentTypes;
